import { connect } from "react-redux";
import AgentsComponents from "../../../Components/DashboardComponent/Body/AgentsComponents";
const mapStateToProps = (state) => ({
    supervisedAgentIds: state.reducer.supervisedAgentIds,
    supervisedAgentDetails:state.reducer.supervisedAgentDetails
});
const mapDispatchToProps = (dispatch) => ({
    
});
 
export default connect(mapStateToProps, mapDispatchToProps)(AgentsComponents);


